
import { ref, defineComponent, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { mapActions, mapGetters, useStore } from "vuex";
import User from "../models/user";

export default defineComponent({
  setup() {
    const loginform: any = ref(null);
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const register = computed(() => store.getters["user/isRegister"]);
    const logged = computed(() => store.getters["user/isLogged"]);
    const goTo = () => {
      if (logged.value && register.value) {
        if (localStorage.getItem("afterLoginPath")) {
          const afterLoginPath = localStorage.getItem(
            "afterLoginPath"
          ) as string;
          router.push({
            name: afterLoginPath,
            params: { eventID },
          });
        } else {
          router.push({
            name: "/",
            params: { eventID },
          });
        }
      }
    };
    const eventID = route.params.eventID;
    const googleLoginAction = async () => {
      await store.dispatch("user/googleLoginAction", route.params.eventID);
    };
    const facebookLoginAction = async () => {
      await store.dispatch("user/facebookLoginAction", route.params.eventID);
    };
    onMounted(() => {
      goTo();
    });
    return {
      loginform,
      googleLoginAction,
      facebookLoginAction,
      eventID,
    };
  },
  data() {
    return {
      form: User.getLoginForm(),
      rememberMe: false,
    };
  },
  computed: {
    ...mapGetters("user", ["eventData"]),
  },
  methods: {
    ...mapActions("user", ["passwordEmailAction"]),
    login() {
      this.loginform.validate((valid) => {
        this.passwordEmailAction({
          email: this.form.email.value,
          password: this.form.password.value,
          eventID: this.eventID,
        });
      });
    },
    goToPasswordRecovery() {
      this.$router.push({ name: "PasswordRecovery" });
    },
  },
});
